import createIcon from '../../createIcon';

/**
 * @component @name CloudCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xNi41IDE2SDhDNi4zNCAxNiA1IDE0LjY2IDUgMTNDNSAxMS4zNCA2LjM0IDEwIDggMTBMOC4xNCAxMC4wMUM4LjU4IDguMjggMTAuMTMgNyAxMiA3QzE0LjIxIDcgMTYgOC43OSAxNiAxMUgxNi41QzE3Ljg4IDExIDE5IDEyLjEyIDE5IDEzLjVDMTkgMTQuODggMTcuODggMTYgMTYuNSAxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CloudCircle = createIcon('CloudCircle', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.5 16H8C6.34 16 5 14.66 5 13C5 11.34 6.34 10 8 10L8.14 10.01C8.58 8.28 10.13 7 12 7C14.21 7 16 8.79 16 11H16.5C17.88 11 19 12.12 19 13.5C19 14.88 17.88 16 16.5 16Z',
      key: 'ihumv',
    },
  ],
]);

export default CloudCircle;
